const errorMessages = {
  'pt-BR': {
    generic: {
      title: 'Erro',
      message: 'Ocorreu um erro inesperado. Por favor tente novamente mais tarde.',
    },
    operacao: {
      cancelada: {
        title: 'Operação Cancelada!',
        message: 'Operação Cancelada!',
      },
      generic: {
        title: 'Erro na operação',
        message: 'Operação Cancelada!',
      }
    },
    form: {
      generic: {
        title: 'Formulário Inválido',
        message: 'Items obrigatório não informados',
      },
    },
    arquivo: {
      generic: {
        title: 'Arquivo inválido',
        message: 'Verifique o arquivo.',
      }
    },
    kraken: {
      generic: {
        title: 'Erro ao carregar os dados',
        message: 'Atualize a página e tente novamente.',
      },
      gravame: {
        title: 'O valor do Gravame não foi carregado',
        message: 'Por gentileza, atualize a página e tente novamente.',
      }
    },
    avalista: {
      generic: {
        title: 'Avalista Obrigatório',
        message: 'Precisa ser informado ao menos um Avalista.'
      },
      informacao: {
        title: 'Informações avalista',
        message: 'Há avalistas com informações requeridas pendentes!'
      },
      documentoFoto: {
        title: 'Documento Obrigatório',
        message: 'Documento com Foto dos Avalistas são Obrigatórios.'
      },
    },
    representanteLegal: {
      generic: {
        title: 'Representante Legal Obrigatório',
        message: 'Precisa ser informado ao menos um Representante Legal.'
      },
      informacao: {
        title: 'Informações Representante Legal',
        message: 'Há Representante Legal com informações requeridas pendentes!'
      },
      documentoFoto: {
        title: 'Documento Obrigatório',
        message: 'Documento com Foto dos Representante Legal são Obrigatórios.'
      },
    },
    devedorSolidario: {
      generic: {
        title: 'Devedor Obrigatório',
        message: 'Deve ser informado ao menos um Devedor Solidário'
      }
    },
    proposta: {
      generic: {
        title: 'Erro proposta',
        message: 'Ocorreu um erro inesperado.'
      },
      inclusao: {
        title: 'Falha na inclusão da proposta',
        message: 'Falha na inclusão da proposta'
      },
      ccb: {
        title: 'Erro',
        message: 'Para finalizar a proposta é necessário digitalizar e enviar a CCB.'
      }
    },
    garantia: {
      generic: {
        title: 'Operação não permitida',
        message: 'Deve ser informado ao menos 1(uma) Garantia'
      },
      erroInclusao: {
        title: 'Operação não concluida',
        message: 'Ocorreu um erro inesperado.'
      }
    },
    backStep: {
      title: 'Erro',
      message: 'Não é possível voltar, pois a proposta já foi criada.'
    },
    parametro: {
      generic: {
        title: 'Parâmetro não cadastrado',
        message: 'Há parâmetro não cadastrado para esse portal.'
      }
    },
    desenbolso: {
      title: 'Erro Desenbolso',
      message: 'Não existe opções de desembolso para o produto selecionado.'
    },
    cliente: {
      generic: {
        title: 'Erro Cliente',
        message: 'Erro com as informações do cliente'
      },
      limite: {
        title: 'Limite Cliente',
        message: 'Cliente não possue limite de crédito.'
      },
      cadastro: {
        title: 'Cadastro Cliente',
        message: 'Cliente não cadastrado!'
      }
    },
    motor: {
      title: 'Erro',
      message: 'Não há dados para consulta ao motor'
    }
  },
  en: {
    generic: {
      title: 'Error',
      message: 'An unexpected error has occurred. Please try again later.',
    },
    operacao: {
      cancelada: {
        title: 'Operation Canceled!',
        message: 'Operation Canceled!',
      },
      generic: {
        title: 'Operation error',
        message: 'Operation Canceled!',
      }
    },
    form: {
      generic: {
        title: 'Invalid Form',
        message: 'Mandatory items not informed',
      },
    },
    arquivo: {
      generic: {
        title: 'Invalid file',
        message: 'Check the file.',
      }
    },
    kraken: {
      generic: {
        title: 'Error loading data',
        message: 'Please refresh the page and try again.',
      },
      gravame: {
        title: 'Encumbrance value was not loaded',
        message: 'Please refresh the page and try again.',
      }
    },
    avalista: {
      generic: {
        title: 'Mandatory Guarantor',
        message: 'At least one Guarantor must be informed.'
      },
      informacao: {
        title: 'Guarantor information',
        message: 'There are guarantors with pending required information!'
      },
      documentoFoto: {
        title: 'Mandatory Document',
        message: 'Document with Photo of Guarantors is Mandatory.'
      },
    },
    representanteLegal: {
      generic: {
        title: 'Mandatory Legal Representative',
        message: 'At least one Legal Representative must be informed.'
      },
      informacao: {
        title: 'Legal Representative information',
        message: 'There are Legal Representative with pending required information!'
      },
      documentoFoto: {
        title: 'Mandatory Document',
        message: 'Document with Photo of Legal Representative is Mandatory.'
      },
    },
    devedorSolidatrio: {
      generic: {
        title: 'Obligatory Debtor',
        message: 'At least one Solidarity Debtor must be informed'
      }
    },
    proposta: {
      generic: {
        title: 'Error in proposal',
        message: 'An unexpected error has occurred.'
      },
      inclusao: {
        title: 'Failure to include the proposal',
        message: 'Failure to include the proposal'
      }
    },
    garantia: {
      generic: {
        title: 'Warranty Error',
        message: 'At least 1 (one) Guarantee must be informed'
      }
    },
    backStep: {
      title: 'Error',
      message: 'It is not possible to return, as the proposal has already been created.'
    },
    parametro: {
      generic: {
        title: 'Unregistered parameter',
        message: 'There is a parameter not registered for this portal.'
      }
    },
    desenbolso: {
      title: 'Disbursement Error',
      message: 'There are no disbursement options for the selected product.'
    },
    cliente: {
      generic: {
        title: 'Customer Error',
        message: 'Error with customer information'
      },
      limite: {
        title: 'Customer Limit',
        message: 'Customer does not have a credit limit.'
      },
      cadastro: {
        title: 'Customer Registration',
        message: 'Customer not registered!'
      }
    }
  }
}

export default errorMessages;
